import { Component } from "react";
import { Button, Col, Row } from "react-bootstrap";

const ButtonControl = (props) =>  {
    const { placeholder, somenteLeitura } = props;
    return <Button {...props} disabled={somenteLeitura} >{placeholder}</Button>;
}

export default ButtonControl;
